import { ASSET_TYPES } from '@exodus/fiat-client'
import { createFiatAsset } from '../utils'
import { units as currencyUnits } from '@exodus/fiat-currencies'

const resultFunction = (assets) => {
  const crypto = {}
  const fiat = {}

  for (const [name, { type, ...rest }] of Object.entries(assets)) {
    if (type === ASSET_TYPES.crypto) {
      crypto[name] = { name, type, ...rest }
    } else if (type === ASSET_TYPES.fiat) {
      const asset = createFiatAsset(currencyUnits[name], rest)

      if (asset) {
        fiat[name] = asset
      }
    }
  }

  return { crypto, fiat }
}

const groupedAssetsSelectorDefinition = {
  id: 'groupedAssets',
  resultFunction,
  dependencies: [{ selector: 'assetData' }],
}

export default groupedAssetsSelectorDefinition
